import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {delay, filter, take, takeUntil} from 'rxjs/operators';

import {CdkConfigService} from '@cdk/services/config.service';
import {CdkNavigationService} from '@cdk/components/navigation/navigation.service';
import {CdkScrollbarDirective} from '@cdk/directives/cdk-scrollbar/cdk-scrollbar.directive';
import {CdkSidebarService} from '@cdk/components/sidebar/sidebar.service';
import { NgClass } from '@angular/common';
import { MatIconButton, MatIcon } from '@cdk/angular/material';
import { CdkScrollbarDirective as CdkScrollbarDirective_1 } from '@cdk/directives/cdk-scrollbar/cdk-scrollbar.directive';
import { CdkNavigationComponent } from '@cdk/components/navigation/navigation.component';

@Component({
    selector: 'navbar-vertical-style-2',
    templateUrl: './style-2.component.html',
    styleUrls: ['./style-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [NgClass, MatIconButton, MatIcon, CdkScrollbarDirective_1, CdkNavigationComponent]
})
export class NavbarVerticalStyle2Component implements OnInit, OnDestroy
{
    _cdkConfigService = inject(CdkConfigService);
    private _cdkNavigationService = inject(CdkNavigationService);
    private _cdkSidebarService = inject(CdkSidebarService);
    private _router = inject(Router);

    cdkConfig: any;
    navigation: any;

    // Private
    private _cdkScrollbar: CdkScrollbarDirective;
    private _unsubscribeAll: Subject<any>;



    /**
     * Constructor
     *
     * @param _cdkConfigService
     * @param _cdkNavigationService
     * @param _cdkSidebarService
     * @param _router
     */
    constructor()
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Directive
    @ViewChild(CdkScrollbarDirective, {static: true})
    set directive(theDirective: CdkScrollbarDirective)
    {
        if ( !theDirective )
        {
            return;
        }

        this._cdkScrollbar = theDirective;

        // Update the scrollbar on collapsable item toggle
        this._cdkNavigationService.onItemCollapseToggled
            .pipe(
                delay(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this._cdkScrollbar.update();
            });

        // Scroll to the active item position
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                    setTimeout(() => {
                        const activeNavItem: any = document.querySelector('navbar .nav-link.active');

                        if ( activeNavItem )
                        {
                            const activeItemOffsetTop       = activeNavItem.offsetTop;
                                  const activeItemOffsetParentTop = activeNavItem.offsetParent.offsetTop;
                                  const scrollDistance            = activeItemOffsetTop - activeItemOffsetParentTop - (48 * 3);

                            this._cdkScrollbar.scrollToTop(scrollDistance);
                        }
                    });
                }
            );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                    if ( this._cdkSidebarService.getSidebar('navbar') )
                    {
                        this._cdkSidebarService.getSidebar('navbar').close();
                    }
                }
            );

        // Get current navigation
        this._cdkNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._cdkNavigationService.getCurrentNavigation();
            });

        // Subscribe to the config changes
        this._cdkConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.cdkConfig = config;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void
    {
        this._cdkSidebarService.getSidebar('navbar').toggleOpen();
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void
    {
        this._cdkSidebarService.getSidebar('navbar').toggleFold();
    }
}
